<template>
    <v-row>
        <v-col cols="12" sm="12">
            <v-card>
                <v-card-text>
                    <v-file-input label="Valitse tiedosto" outlined @change="onFileChange"
                        ref="excelInput"></v-file-input>
                    <br>
                    <template v-if="error">
                        <v-alert color="error" text>
                            {{ error }}
                        </v-alert>
                    </template>

                    <div class="ml-4">
                        <v-checkbox v-model="invited" label="Kutsutaan Piirin ulkopuolelta"></v-checkbox>
                    </div>

                    <v-simple-table>
                        <thead>
                            <tr>
                                <th>
                                    <v-checkbox @change="toggleAll"></v-checkbox>
                                </th>
                                <th>Etunimi</th>
                                <th>Sukunimi</th>
                                <th>Puhelinnumero</th>
                                <th>Sähköpostiosoite</th>
                                <th>Työtehtävä</th>
                                <th>Näytä puhelin</th>
                                <th>Näytä sähköposti</th>
                                <th>Aikavyöhyke</th>
                                <th>Ryhmät</th>
                                <th>Osastot</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(person, index) in persons" :key="index">
                                <td>
                                    <v-checkbox v-model="person.selected"></v-checkbox>
                                </td>
                                <td>
                                    <v-text-field dense style="min-width: 140px" outlined
                                        v-model="person.firstname"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense style="min-width: 140px" outlined
                                        v-model="person.lastname"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense style="min-width: 140px" outlined
                                        v-model="person.phonenumber"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense outlined v-model="person.email"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense outlined v-model="person.title"></v-text-field>
                                </td>
                                <td>
                                    <v-checkbox style="float: left;" dense v-model="person.show_phone"></v-checkbox>
                                </td>
                                <td>
                                    <v-checkbox style="float: left;" dense v-model="person.show_email"></v-checkbox>
                                </td>
                                <td>
                                    <v-text-field dense outlined v-model="person.timezone"></v-text-field>
                                </td>
                                <td>
                                    <div style="width: 400px">
                                        <v-checkbox style="float: left;" dense v-model="person.groups"
                                            v-for="group in groups" :label="group.name" :value="group.id"
                                            :key="group.id"></v-checkbox>
                                    </div>
                                </td>
                                <td>
                                    <div style="width: 400px">
                                        <v-checkbox style="float: left;" dense v-model="person.departments"
                                            v-for="dep in departments" :label="dep.name" :value="dep.id"
                                            :key="dep.id"></v-checkbox>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <br>
                    <v-btn :loading="importing" v-if="persons.length" color="primary" @click="importPersons">Tuo valitut
                        henkilöt</v-btn>
                    <br>
                    <template v-if="importResult.length">
                        <br>
                        <v-alert text color="info">
                            <div v-for="(result, i) in importResult" :key="i">
                                <span :style="{ 'color': result.ok ? '#35d735' : '#ff1e1e' }">
                                    {{ result.message }}</span>
                            </div>
                        </v-alert>
                    </template>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

import readXlsxFile from 'read-excel-file'
import { computed, ref } from '@vue/composition-api';
import schema from './schema';
import useAuth from '@/useAuth';
import adminApi from '@/api/admin';

export default {
    setup() {

        const persons = ref([]);
        const error = ref("");
        const { user, tenant } = useAuth();
        const excelInput = ref(null);
        const importing = ref(false);
        const importResult = ref([]);
        const invited = ref(true);

        const onFileChange = (file) => {
            error.value = "";
            readXlsxFile(file).then((rows) => {

                const result = [];

                rows.forEach((row, index) => {
                    if (index == 0)
                        return;

                    var person = {
                        selected: true,
                        firstname: row[0],
                        lastname: row[1],
                        phonenumber: row[2].replace(" ", ""),
                        email: row[3] ?? '',
                        title: row[4] ?? '',
                        show_phone: !!row[5],
                        show_email: !!row[6],
                        timezone: row[7],
                        groups: [],
                        departments: [],
                        invited: invited.value
                    };

                    let atCol = 8;

                    if (row.length > (atCol - 1)) {
                        for (let i = atCol; i < row.length; i++) {
                            if (!rows[0][i].toLowerCase().startsWith('g-')) {
                                atCol = i;
                                break;
                            }

                            if (row[i] && row[i].length) {
                                const groupId = parseInt(rows[0][i].split('-')[1]);
                                person.groups.push(groupId);
                            }
                        }
                    }

                    if (row.length > (atCol - 1)) {
                        for (let i = atCol; i < row.length; i++) {
                            if (!rows[0][i].toLowerCase().startsWith('d-'))
                                break;

                            if (row[i] && row[i].length) {
                                const depId = parseInt(rows[0][i].split('-')[1]);
                                person.departments.push(depId);
                            }
                        }
                    }

                    result.push(person);
                });

                persons.value = result;
            })
        }

        const groups = computed(() => {
            return user.value.admin_groups.filter(a => a.group_type == 2);
        });

        const departments = computed(() => {
            return tenant.value.departments;
        });

        const toggleAll = (selected) => {
            persons.value.forEach(p => {
                p.selected = selected;
            });
        }

        const importPersons = async () => {
            importResult.value = [];
            const selectedPersons = persons.value.filter(a => a.selected === true);

            if (selectedPersons.length) {
                importing.value = true;

                for (let i = 0; i < selectedPersons.length; i++) {
                    selectedPersons[i].invited = invited.value;
                    const res = await adminApi.importUser(selectedPersons[i]);
                    if (res.ok)
                        importResult.value.push(res.data);
                    else
                        importResult.value.push({
                            ok: false,
                            message: JSON.stringify(res.data)
                        });

                }
            }

            importing.value = false;
        }

        return {
            onFileChange,
            excelInput,
            persons,
            error,
            importPersons,
            groups,
            departments,
            toggleAll,
            importResult,
            importing,
            invited
        }
    }
}
</script>

<style></style>